export function getCommandBarShortcutLabel(): string {
  if (typeof navigator === 'undefined') {
    return 'Ctrl+K'
  }

  const platform = navigator.platform?.toLowerCase() ?? ''
  const userAgent = navigator.userAgent?.toLowerCase() ?? ''
  const isMac = platform.includes('mac') || userAgent.includes('mac')

  return isMac ? '⌘K' : 'Ctrl+K'
}
